@file:OptIn(InternalResourceApi::class)

package qfast.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.FontResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/qfast.shared.generated.resources/"

@delegate:ResourceContentHash(-849_705_592)
internal val Res.font.prompt_bold: FontResource by lazy {
      FontResource("font:prompt_bold", setOf(
        ResourceItem(setOf(), "${MD}font/prompt_bold.ttf", -1, -1),
      ))
    }

@delegate:ResourceContentHash(-1_553_714_210)
internal val Res.font.prompt_regular: FontResource by lazy {
      FontResource("font:prompt_regular", setOf(
        ResourceItem(setOf(), "${MD}font/prompt_regular.ttf", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainFont0Resources(map: MutableMap<String, FontResource>) {
  map.put("prompt_bold", Res.font.prompt_bold)
  map.put("prompt_regular", Res.font.prompt_regular)
}
